const url = '/supplier-apply-bank-transfer-charge-options';
const Provider = 'SupplierApplyBankTransferChargeOptions';
const dbModel = 'SupplierApplyBankTransferChargeOptions';

export { url, Provider, dbModel };
